import { IconButton, styled } from "@mui/material";

export const DarkIconButton = styled(IconButton)({
  backgroundColor: "rgba(0,0,0,0.6) !important",
  color: "white",
  "&.Mui-disabled": {
    color: "rgba(255,255,255,0.5)",
  },
});
